export const stylePrejoin = {
    readyjoin: { fontSize: '1.75rem',
        color: '#000' },
    readySpan: {
        backgroundColor: '#4e6372',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '20px',
        display: 'inline-flex'
    },
    readySpan1: {
        backgroundColor: '#4e6372',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '20px',
        display: 'inline-flex',
        margin: '15px 0',
        width: '85%'
    },
    readyIconSpan: { marginTop: '2px',
        paddingLeft: '2px' },
    readyForm: {
        width: '80%',
        margin: 'auto',
        marginTop: '15px'
    },
    readyh4: {
        fontSize: '1.5rem',
        color: '#000',
        marginBottom: '5px'
    },
    readyStrong: {
        fontSize: '12px',
        color: '#000'
    },
    alignCenter: { width: '80%',
        maxWidth: '800px',
        borderRadius: '10px',
        margin: 'auto',
        backgroundColor: '#f6f6f6',
        color: '#000',
        padding: '20px',
        marginTop: '51px' },
    loadingImg: { width: '80px' },
    h4Style: { marginTop: '10px',
        color: '#000',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '1.5rem',
        fontWeight: '500',
        lineHeight: '1.2' },
    iconStyle: {
        marginTop: '5px',
        marginRight: '5px'
    },
    margin20: {
        marginTop: '20px'
    }


};
